import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Text } from '@chakra-ui/react';

import { logoLanguage } from 'util/lang';

import { Layout } from './layout/Layout';
import { LogoWithTagLine } from './logo/LogoWithTagline';

const ErrorBoundaryFallback = () => {
  const { t } = useTranslation('naban');

  const web = useMemo(() => {
    const websites = {
      fr: {
        label: 'notaire.be',
        route: 'https://www.notaire.be',
      },
      nl: {
        label: 'notaris.be',
        route: 'https://www.notaris.be',
      },
    };

    return websites[logoLanguage] ?? websites.fr;
  }, []);

  return (
    <Layout>
      <Flex
        width='full'
        alignItems='center'
        justifyContent='center'
        flexDirection='column'
        p={16}
        flex={1}>
        <LogoWithTagLine />
        <Flex flexDirection='column' alignItems='center' justifyContent='center' gap={8} flex={1}>
          <Text variant='heading1' textAlign='center'>
            {t('errorBoundary.title')}
          </Text>
          <Text textAlign='center' maxW='30rem'>
            {t('errorBoundary.description')}
          </Text>
          <Button as='a' variant='secondary100' href={web.route} mt={8}>
            {t('logout.success.backToWeb.label', { name: web.label })}
          </Button>
        </Flex>
      </Flex>
    </Layout>
  );
};

export default ErrorBoundaryFallback;
